// ======================================================================
// Component: RuleList
// Purpose: Displays Automation Rules table
// ======================================================================

import React from "react";

export default function RuleList({ rules, loading }) {

  return (
    <div className="card">
      <div className="card-body p-0">

        <table className="table table-bordered mb-0">
          <thead className="table-light">
            <tr>
              <th>Rule Name</th>
              <th>Event</th>
              <th>Action</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>

            {loading && (
              <tr>
                <td colSpan="4" className="text-center">
                  Loading...
                </td>
              </tr>
            )}

            {!loading && rules.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No automation rules configured
                </td>
              </tr>
            )}

            {!loading && rules.map(rule => (
              <tr key={rule.id}>
                <td>{rule.rule_name}</td>
                <td>{rule.trigger_event}</td>
                <td>{rule.action_type}</td>
                <td>
                  {rule.is_active ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Disabled</span>
                  )}
                </td>
              </tr>
            ))}

          </tbody>
        </table>

      </div>
    </div>
  );
}
